import React, { FC, useMemo } from 'react'
import { ControlledHiddenInput } from 'transfix-form/components'
import CreateNewIssueForm from '../../CreateNewIssueModal/CreateNewIssueForm'
import { useShipmentIssuesModalQuery } from '../../CreateNewIssueModal/graphql/ShipmentIssuesModal'
import { useCreateIssueModalFormContext } from './LoadUpdateSchema'

interface ICreateIssueFormProps {
  shipmentId: string
  parentShowOther?: boolean
  setParentShowOther?: (value: boolean) => void
  showSuggestedGroupOwners?: boolean
}

export const CreateIssueForm: FC<ICreateIssueFormProps> = ({
  children,
  shipmentId,
  parentShowOther = true,
  setParentShowOther = () => {},
  showSuggestedGroupOwners = true,
}) => {
  const { control, errors, setValue } = useCreateIssueModalFormContext()
  const { data } = useShipmentIssuesModalQuery({
    variables: {
      id: shipmentId,
    },
  })

  const issues = useMemo(() => {
    return data?.shipment?.issues || []
  }, [data])

  return (
    <CreateNewIssueForm
      control={control}
      issues={issues}
      shipmentId={shipmentId}
      errors={errors}
      setValue={setValue}
      hideIssueType
      hideStepsToResolve
      hidePriorityInfo
      parentShowOther={parentShowOther}
      setParentShowOther={setParentShowOther}
      showSuggestedGroupOwners={showSuggestedGroupOwners}>
      {children}
      <ControlledHiddenInput name='shipmentIssueTypeId' control={control} />
    </CreateNewIssueForm>
  )
}
